import { getSearchParamsString } from '@reapitform/utils'
import { getUrl, usePlatformGet } from '@reapitform/hooks'
import { IPaginationParams, IResponseWithPagination } from '../../types'
import { useMemo } from 'react'
import { IDefaultEmergencyContact } from '../../types/default-emergency-contact'
import { useQueryClient } from '@tanstack/react-query'

export const useDefaultEmergencyContact = (params: IPaginationParams) => {
  const queryClient = useQueryClient()

  const searchParams = getSearchParamsString(params)
  const path: string = `/api/Organization/DefaultRepairer${searchParams}`
  const [result, loading, errorString] = usePlatformGet<IResponseWithPagination<IDefaultEmergencyContact>>({
    path,
    retry: false,
  })

  const queryKey = useMemo(getUrl(path), [path])

  const { _embedded, ...pagination } = result ?? {}

  const updateCacheData = (
    data: IDefaultEmergencyContact[] | ((preData: IDefaultEmergencyContact[]) => IDefaultEmergencyContact[]),
  ) => {
    if (!queryClient) return

    queryClient.setQueryData([queryKey], (prevData: IResponseWithPagination<IDefaultEmergencyContact>) => {
      let newValue = data
      if (typeof data === 'function') newValue = data(prevData._embedded)

      return { ...prevData, _embedded: newValue }
    })

    queryClient.invalidateQueries({ queryKey: [queryKey] })
  }

  return { data: _embedded, pagination: pagination, loading, errorString, updateCacheData }
}
